import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from '@pwc/pwc-deals-ui';
import Separator from '../Separator';
import './source-display.scss';

const SourceDisplay = ({ sourceText, icon, showSeparator }) => {
  return sourceText ? (
    <div className="source-display" data-testid="source-display">
      {icon && <Icon name={icon} className="fill" width={12} />}
      {showSeparator && (
        <>
          Source <Separator /> <div className="source-text">{sourceText}</div>
        </>
      )}
      {!showSeparator && <>Source: {sourceText}</>}
    </div>
  ) : (
    <></>
  );
};

SourceDisplay.propTypes = {
  sourceText: PropTypes.string.isRequired,
};

export default SourceDisplay;
